export default function buildLink(path) {
  const { origin } = window.location;

  return `${origin}${path}`;
}
